import { render, staticRenderFns } from "./FirstUsePage.vue?vue&type=template&id=04c26530&scoped=true&"
import script from "./FirstUsePage.vue?vue&type=script&lang=js&"
export * from "./FirstUsePage.vue?vue&type=script&lang=js&"
import style0 from "./FirstUsePage.vue?vue&type=style&index=0&id=04c26530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c26530",
  null
  
)

export default component.exports